/**
 * Strip the plugin namespace prefix from tool names.
 * `plugin__google-workspace__list_events` → `list_events`
 * `send_email` → `send_email` (unchanged)
 */
export function normalizeToolName(fullName: string): string {
  if (!fullName.startsWith('plugin__')) return fullName
  const parts = fullName.split('__')
  // parts: ['plugin', pluginId, ...toolName]
  return parts.slice(2).join('__')
}

/**
 * Convert a snake_case tool name to a human-readable label.
 * `get_current_time` → `Getting current time`
 * `save_to_notebook` → `Saving to notebook`
 * Used as fallback when no i18n translation exists.
 */
export function humanizeToolName(snakeName: string): string {
  const words = snakeName.replace(/_/g, ' ')
  // Convert leading verb to gerund (-ing form) for activity context
  const first = words.split(' ')[0] ?? ''
  const rest = words.slice(first.length)
  const gerund = toGerund(first)
  const label = gerund + rest
  return label.charAt(0).toUpperCase() + label.slice(1)
}

function toGerund(verb: string): string {
  if (verb.endsWith('e') && !verb.endsWith('ee')) return verb.slice(0, -1) + 'ing'
  if (/^[a-z]+[bcdfghjklmnpqrstvwxyz]$/.test(verb) && verb.length <= 4) {
    // Double final consonant for short verbs: get → getting, set → setting
    return verb + verb.slice(-1) + 'ing'
  }
  return verb + 'ing'
}
